import { registerPlugin } from '@capacitor/core';
import type { ScreenshotConnectionPlugin as ScreenshotConnectionPluginType } from './definitions';

const ScreenshotConnectionPlugin = registerPlugin<ScreenshotConnectionPluginType>(
  'ScreenshotConnectionPlugin',
);

// eslint-disable-next-line import-x/export
export * from './definitions';
// eslint-disable-next-line import-x/export
export { ScreenshotConnectionPlugin };
